import { Navigate, useRouterState } from "@tanstack/react-router";
import { usePermissions } from "@/shared/hooks/usePermissions";
import { permissionForRoute } from "@/shared/components/sidebar/routePermissionRegistry";
import { PermissionType } from "@/pages/Configuration/AdminConfiguration/Users/types/cognitoTypes";

export function MfeMount() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { permissions, hasPermission } = usePermissions();

  const required = permissionForRoute(pathname);
  const denied =
    required != null &&
    (permissions.length > 0 || required === PermissionType.Plan) &&
    !hasPermission(required);

  if (denied) {
    return <Navigate to="/access-denied" />;
  }

  // The MFE mount node (#single-spa-app-container) is owned by the root chrome
  // (__root.tsx) as a stable, absolutely-positioned box filling the content
  // area. This route only gates access; it must not render a second container.
  return null;
}
